import { BaseException } from './base.exception.js';

export class ArgumentException extends BaseException {
  private static readonly ERROR: string = 'Argument exception';

  constructor(message: string, extraData?: string | object) {
    super(message, extraData);
  }

  public getError(): string {
    return ArgumentException.ERROR;
  }
}
